import {Fragment, Node} from 'prosemirror-model';
import {EditorState} from 'prosemirror-state';

export function canReplaceSelection(state: EditorState, node: Node) {
  const {$from, $to} = state.selection;

  return $from.parent.canReplace($from.index(), $to.index(), Fragment.from(node));
}
